<template>
  <el-dropdown trigger="click" @command="handleSwitch">
    <div class="lang-switch">
      <Icon name="Globe" :size="16" v-if="hasGlobeIcon" />
      <span v-else class="lang-label">{{ currentLabel }}</span>
      <Icon name="ChevronDown" :size="12" />
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item
          v-for="lang in languages"
          :key="lang.value"
          :command="lang.value"
          :class="{ 'is-active': locale === lang.value }"
        >
          {{ lang.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { setLocale } from '@/locales'
import { switchVxeTableLocale } from '@/plugins/vxe-table'
import Icon from '@/components/Icon/index.vue'

const { locale } = useI18n()

const languages = [
  { label: '简体中文', value: 'zh-CN' },
  { label: 'English', value: 'en-US' },
]

const currentLabel = computed(() => locale.value === 'zh-CN' ? '中' : 'EN')

// Check if Globe icon is registered (it may not be in commonLucideIcons)
const hasGlobeIcon = false // Use text label instead for reliability

function handleSwitch(lang) {
  if (lang === locale.value) return
  setLocale(lang)
  switchVxeTableLocale(lang)
}
</script>

<style lang="scss" scoped>
.lang-switch {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  cursor: pointer;
  border-radius: var(--radius-base);
  color: var(--text-secondary);
  font-size: var(--font-size-secondary);
  transition: all var(--transition-base);

  &:hover {
    color: var(--text-regular);
    background: var(--bg-page);
  }
}

.lang-label {
  font-weight: 500;
  font-size: var(--font-size-small);
}

:deep(.el-dropdown-menu__item) {
  &.is-active {
    color: var(--primary);
    font-weight: 500;
  }
}
</style>
